import { render, staticRenderFns } from "./CVQuickMenu.vue?vue&type=template&id=68819f96&scoped=true"
import script from "./CVQuickMenu.vue?vue&type=script&lang=js"
export * from "./CVQuickMenu.vue?vue&type=script&lang=js"
import style0 from "./CVQuickMenu.vue?vue&type=style&index=0&id=68819f96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68819f96",
  null
  
)

export default component.exports